import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function Industries() {
	return (
		<>
			<Helmet>
				<title>Service Areas | Apex Specialty Contracting LLC – Tampa Bay Roofing</title>
				<meta name="description" content="Apex Specialty Contracting LLC serves homeowners and businesses throughout the Tampa Bay area including Tarpon Springs, Clearwater, Tampa, St. Petersburg, and surrounding communities." />
			</Helmet>
			<PageHeader
				title="Our Service Areas"
				subtitle="Proudly serving roofing and storm restoration customers throughout Pinellas, Pasco, and Hillsborough counties."
			/>
			<section className="section">
				<div className="container">
					<p className="helper" style={{ maxWidth: 640, marginBottom: 28 }}>
						Based in Tarpon Springs, Florida, Apex Specialty Contracting serves residential and commercial roofing customers across the greater Tampa Bay region. If you don't see your city listed, call us — we likely serve your area.
					</p>
					<h2>Pinellas County</h2>
					<div className="grid grid-3 features" style={{ marginTop: 16 }}>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Tarpon Springs</h3>
							<p className="helper">Our home base. We serve residential and commercial roofing customers throughout Tarpon Springs and the surrounding neighborhoods.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Clearwater</h3>
							<p className="helper">Roof replacements, storm damage repairs, and inspections for Clearwater homeowners and commercial property owners.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>St. Petersburg</h3>
							<p className="helper">Full roofing services for the St. Pete area, including roof replacement, repairs, and gutter installation.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Palm Harbor</h3>
							<p className="helper">Serving Palm Harbor neighborhoods with expert roofing, storm restoration, and preventive inspections.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Dunedin</h3>
							<p className="helper">Residential roofing and gutter services for Dunedin and the surrounding area.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Safety Harbor</h3>
							<p className="helper">Roof inspections, repairs, and replacements for Safety Harbor residents and businesses.</p>
						</div>
					</div>

					<h2 style={{ marginTop: 40 }}>Pasco County</h2>
					<div className="grid grid-3 features" style={{ marginTop: 16 }}>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>New Port Richey</h3>
							<p className="helper">Full-service roofing for New Port Richey and surrounding Pasco County communities.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Holiday</h3>
							<p className="helper">Roof replacement and storm damage repair services for Holiday and Port Richey homeowners.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Trinity</h3>
							<p className="helper">Serving Trinity and Land O' Lakes with quality roofing and gutter installation services.</p>
						</div>
					</div>

					<h2 style={{ marginTop: 40 }}>Hillsborough County</h2>
					<div className="grid grid-3 features" style={{ marginTop: 16 }}>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Tampa</h3>
							<p className="helper">Commercial and residential roofing throughout Tampa, including storm restoration and insurance claim support.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Brandon</h3>
							<p className="helper">Roof inspections, repairs, and full replacements for Brandon and Riverview homeowners.</p>
						</div>
						<div className="card feature">
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
							</div>
							<h3>Wesley Chapel</h3>
							<p className="helper">Serving Wesley Chapel and Zephyrhills with professional roofing services and insurance claim expertise.</p>
						</div>
					</div>

					<div className="card" style={{ padding: 24, marginTop: 36, textAlign: 'center' }}>
						<h3>Don't see your city?</h3>
						<p className="helper">We serve many more communities throughout the Tampa Bay area. Call us to confirm we service your location — free of charge.</p>
						<div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginTop: 14 }}>
							<Link className="btn" to="/contact">Request a Free Estimate</Link>
							<a className="btn-outline" href="tel:9163160696">Call (916) 316-0696</a>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default Industries;
